export interface ShouldCommitPendingCreateArgs {
  searchable?: boolean
  searchFilter?: string
  onCreateOption?: (value: string) => void
  validateCreatedOption?: (value: string) => string | undefined
}

/**
 * Decides whether a click-away should commit the text the user typed into the search bar
 * as a created option, instead of discarding it.
 *
 * Committing is gated on `validateCreatedOption` so that selects whose search bar is only
 * a filter never turn filter text into a value. Only selects that describe what a valid
 * created option looks like (AddressBookSelect) opt in.
 *
 * That gate is load-bearing, and it is opt-in by omission. Adding `validateCreatedOption` to
 * another select does two things beyond validation: click-away starts committing its typed
 * text, and DropdownSelect switches its ClickAwayListener to `onMouseDown` while text is
 * pending. Only add the prop to a select whose search text is genuinely a value, not a filter.
 */
export function shouldCommitPendingCreate({
  searchable,
  searchFilter,
  onCreateOption,
  validateCreatedOption
}: ShouldCommitPendingCreateArgs): boolean {
  if (!onCreateOption || !searchable || !validateCreatedOption) {
    return false
  }

  if (!searchFilter?.trim()) {
    return false
  }

  return !validateCreatedOption(searchFilter)
}
